<template functional>
    <a
        href="/"
        :class="{
            'header-logo': true,
            [props.classList]: !!props.classList,
        }"
    >
        <slot>Банк ДОМ.РФ - универсальный ипотечно-строительный банк</slot>
        <img
            v-if="props.lang === 'ru'"
            :src="props.dark ? '/local/templates/redesign/src/assets/img/logo-main-white.svg' : '/local/templates/redesign/src/assets/img/logo-main.svg'"
            alt="Логотип Банк ДОМ.РФ"
        >
        <img
            v-else
            src="/local/templates/redesign/src/assets/img/logo-eng.svg"
            alt="Bank DOM.RF"
        >
    </a>
</template>
<script>
export default {
    name: 'HeaderLogo',
    props: {
        dark: Boolean,
        lang: {
            type: String,
            default: 'ru',
            validator: (val) => ['eng', 'ru', 'cn'].includes(val),
        },
        classList: String,
    },
};
</script>
<style lang="scss">
@import "../../assets/scss/base/variables";
@import "../../assets/scss/base/mixins";
@import "../../assets/scss/base/functions";

.header-logo {
    @include fluid('width', 110px, 88px);
    @include fluid('height', 40px, 32px);
    @include fluid('margin-right', 43px, 20px);
    display: block;
    font-size: 0;

    > img	{
        max-width: 100%;
        width: 100%;
        height: auto;
        aspect-ratio: 110/40;
        object-fit: contain;
    }
}
</style>
